import { computed, Service, signal } from '@angular/core';
import { KEYBOARD_HEIGHT_PX } from './keyboard.model';

/** Minimal contract for the active keyboard host (avoids circular imports). */
export interface KeyboardHost {
	closeKeyboard(): void;
}

@Service()
export class KeyboardService {
	private readonly _visibility = signal(false);
	readonly visibility = this._visibility.asReadonly();

	/** Bottom inset (px) to keep UI above the fixed keyboard overlay. */
	readonly bottomOffset = computed(() => (this._visibility() ? KEYBOARD_HEIGHT_PX : 0));

	private activeHost: KeyboardHost | null = null;

	setVisibility(value: boolean): void {
		this._visibility.set(value);
	}

	hasOpenKeyboard(): boolean {
		return this._visibility();
	}

	/** Closes any previously active keyboard before a new field opens one. */
	requestOpen(host: KeyboardHost): void {
		if (this.activeHost && this.activeHost !== host) {
			this.activeHost.closeKeyboard();
		}
		this.activeHost = host;
	}

	clearActive(host: KeyboardHost): void {
		if (this.activeHost === host) {
			this.activeHost = null;
		}
	}
}
